import { render } from "./P012.vue?vue&type=template&id=7cc01de4&scoped=true"
import script from "./P012.vue?vue&type=script&lang=js"
export * from "./P012.vue?vue&type=script&lang=js"

import "./P012.vue?vue&type=style&index=0&id=7cc01de4&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc01de4"]])

export default __exports__